import type { ArenaBlock, ArenaConnectionSummary, ArenaSearchResponse } from "../types/arena";

export function normalizeBlockType(block: Partial<ArenaBlock>): string {
  return (block.class || block.type || "Unknown") as string;
}

export function normalizeBlockBaseType(block: Partial<ArenaBlock>): string {
  return (block.base_class || block.base_type || "Unknown") as string;
}

export function extractFirstSearchResult(payload: ArenaSearchResponse): ArenaBlock | null {
  if (Array.isArray(payload?.data) && payload.data.length > 0) {
    return payload.data[0];
  }
  if (Array.isArray(payload?.blocks) && payload.blocks.length > 0) {
    return payload.blocks[0];
  }
  return null;
}

export function getConnectionsHref(block: Partial<ArenaBlock>): string | null {
  return block?._links?.connections?.href || null;
}

export function normalizeConnections(
  payload: { data?: ArenaConnectionSummary[]; connections?: ArenaConnectionSummary[] } | ArenaConnectionSummary[]
): ArenaConnectionSummary[] {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  if (Array.isArray(payload?.connections)) {
    return payload.connections;
  }
  return [];
}
